module.exports = "/virtual-football-league/img/amblems/left/logos/Get.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Get.png
// module id = 2095
// module chunks = 4